// غلاف صغير فوق IndexedDB: تخزين الجهاز الذي تعيش فيه الفحوصات غير المرفوعة وصورها
// والبيانات المرجعية. localStorage لا يصلح هنا: سعته صغيرة ولا يحفظ الصور.
const DB_NAME = 'scancar-offline';
const DB_VERSION = 1;

export const STORES = {
  kv: 'kv',
  drafts: 'drafts',
  blobs: 'blobs',
};

let dbPromise = null;

function openDb() {
  if (dbPromise) return dbPromise;

  dbPromise = new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') {
      reject(new Error('هذا المتصفح لا يدعم التخزين على الجهاز.'));
      return;
    }

    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORES.kv)) db.createObjectStore(STORES.kv);
      if (!db.objectStoreNames.contains(STORES.drafts)) db.createObjectStore(STORES.drafts, { keyPath: 'id' });
      if (!db.objectStoreNames.contains(STORES.blobs)) db.createObjectStore(STORES.blobs);
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => {
      dbPromise = null;
      reject(request.error);
    };
  });

  return dbPromise;
}

async function run(storeName, mode, operation) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, mode);
    const request = operation(tx.objectStore(storeName));
    tx.oncomplete = () => resolve(request ? request.result : undefined);
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error || new Error('تعذّر الحفظ على الجهاز.'));
  });
}

export function idbGet(storeName, key) {
  return run(storeName, 'readonly', (store) => store.get(key));
}

export function idbGetAll(storeName) {
  return run(storeName, 'readonly', (store) => store.getAll());
}

export function idbPut(storeName, value, key) {
  return run(storeName, 'readwrite', (store) => (key === undefined ? store.put(value) : store.put(value, key)));
}

export function idbDelete(storeName, key) {
  return run(storeName, 'readwrite', (store) => store.delete(key));
}

// يطلب من المتصفح ألا يمسح تخزين الموقع تحت ضغط الذاكرة. المتصفح قد يرفض، والتطبيق يعمل في الحالتين.
export async function requestPersistentStorage() {
  try {
    if (navigator?.storage?.persisted && await navigator.storage.persisted()) return true;
    return Boolean(await navigator?.storage?.persist?.());
  } catch {
    return false;
  }
}
